<div class="zoom-slider d-flex gap-2 align-items-center">

  <a href="#" (click)="zoomPreset('page-fit')" class="zoom-icon">
    <svg-icon src="/assets/icon-page-fit.svg"></svg-icon>
  </a>

  <a href="#" (click)="zoomPreset('page-width')" class="zoom-icon">
    <svg-icon src="/assets/icon-page-width.svg"></svg-icon>
  </a>

  <a href="#" (click)="zoomOut()">
    <i class="bi bi-dash"></i>
  </a>
  <ngx-slider [(value)]="value" [options]="options" (userChange)="onUserChange($event)"></ngx-slider>
  <a href="#" (click)="zoomIn()">
    <i class="bi bi-plus"></i>
  </a>
  <span class="zoom-percentage">{{ value }}%</span>
</div>
